module.exports = __webpack_public_path__ + "static/media/Artboard4.65774e68.png";